<template>
  <div class="news-detail-container">
    <!-- 顶部导航路径 -->
    <div class="nav-path">
      <div class="path-content">
        <span @click="goHome">领点回收官网 ></span>
        <span class="separator"v-if="!$route.query.home"></span>
        <span @click="goReturn" v-if="!$route.query.home">帮助中心 ></span>
        <span class="separator"v-if="!$route.query.home"></span>
        <span @click="goBack"v-if="!$route.query.home">{{newsDetail.type}} ></span>
        <span class="separator"></span>
        <span class="current" style="color: #488eff" >{{newsDetail.title}}</span>
      </div>
    </div>

    <!-- 文章内容区域 -->
    <div class="article-container">
      <div class="article-content">
        <!-- 文章标题 -->
        <h1 class="article-title">{{newsDetail.title}}</h1>

        <!-- 文章信息 -->
        <div class="article-info">
          <span class="author">领点回收官方</span>
          <span class="category">分类：{{newsDetail.type}}</span>
          <span class="time" v-show="newsDetail.type == '网站公告'">发布时间：{{newsDetail.createTime}}</span>
        </div>
        <!-- 文章正文 -->
        <div class="article-body">
<!--          <p v-html="newsDetail.link"></p>-->
          <iframe :src="newsDetail.link" style="width: 100%; height: 600px; border: none;">
          </iframe>
        </div>
      </div>
      <!-- 右侧其他问题 -->
      <div class="other-questions" v-if="1+1 == 3">
        <div class="other-title">
          <i class="el-icon-question"></i>
          <span>其他问题</span>
        </div>
        <div class="question-list">
          <div class="question-item">
            <span class="label">下一篇 |</span>
            <a href="/news/detail/10111">领点回收如何查看支持回收的产品有哪些？</a>
            <span class="time">2018-09-19 15:48:22</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  name: 'NewsDetail',
  data() {
    return {
        newsDetail:{}
      // 数据可以根据实际需求添加
    }
  },
  mounted() {
    this.newsDetail = this.$route.query.news;
    console.log("this.newsDetail", this.newsDetail)
    // this.getNewsDetail()
  },
  methods: {
    goBack(){
        let type = "0";
        if(this.newsDetail.type == "常见问题"){
            type = "8"
        }else if(this.newsDetail.type == "网站公告"){
            type = "7"
        }
        this.$store.commit('changedMenuId',type)
        this.$router.go(-1)

    },
    goHome(){
      this.$router.push({ path: "/" });

    },
    goReturn(){
      this.$router.go(-1)
    },
    // 获取新闻详情
    // getNewsDetail() {
    //   http.get("/article/details/" + this.$route.query.id).then((response) => {
    //
    //     if (response.code === 200) {
    //       this.newsDetail = response.data
    //     }
    //   })
    // }
  }

}
</script>

<style lang="less" scoped>
.news-detail-container {
  min-height: 100vh;
  background-color: #f5f6fa;
  padding-bottom: 40px;

  .nav-path {
    border-bottom: 1px solid #eee;

    .path-content {
      max-width: 1200px;
      margin: 0 auto;
      padding: 15px 20px;
      color: #666;
      font-size: 14px;

      .separator {
        margin: 0 4px;
        color: #999;
      }

      .current {
        color: #333;
      }
    }
  }

  .article-container {
    max-width: 1200px;
    margin: 20px auto;
    display: flex;
    gap: 20px;

    .article-content {
      flex: 1;
      background: #fff;
      padding: 30px;
      border-radius: 8px;

      .article-title {
        font-size: 22px;
        font-weight: 500;
        color: #333;
        margin-bottom: 20px;
      }

      .article-info {
        display: flex;
        gap: 20px;
        color: #999;
        font-size: 14px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
      }

      .article-body {
        color: #333;
        line-height: 1.8;

        p {
          margin-bottom: 15px;
        }

        .step {
          .step-num {
            color: #ff4215;
            font-weight: 500;
          }

          .step-content {
            color: #333;
          }
        }
      }
    }

    .other-questions {
      width: 300px;
      background: #fff;
      border-radius: 8px;
      padding: 20px;

      .other-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 20px;

        i {
          color: #488eff;
        }
      }

      .question-item {
        font-size: 14px;
        margin-bottom: 15px;

        .label {
          color: #666;
        }

        a {
          color: #333;
          text-decoration: none;
          margin: 0 5px;

          &:hover {
            color: #488eff;
            text-decoration: underline;
          }
        }

        .time {
          display: block;
          color: #999;
          margin-top: 5px;
          margin-left: 45px;
        }
      }
    }
  }
}
</style>
